import * as React from 'react';
import { connect } from 'react-redux';
import i18n from '../../i18n';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import * as AppDataStore from '../../store/AppData';
import Stack from '@mui/material/Stack';
import { Box, Typography } from '@mui/material';
import { ReactComponent as SuccessIcon } from '../../assets/successZ.svg';
const ZoomAuthSuccess = (props: any) => {
    const appLanguage = useSelector((state: ApplicationState) => state.appData?.app4legalData?.lang);
    i18n.changeLanguage(localStorage.getItem("lang"));

    React.useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search)
        const tokens = queryParams.get("tokens");
        if (tokens) {
            props.fillTokens(tokens);
        }
        window.opener.callBackAuthZoom(tokens);
        setTimeout(() => {
            window.close();
        }, 1500)
    }, []);

    return (
        <div>
            <Box>
                <Stack sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                }}
                    spacing={2} alignItems="center">
                    <div style={{
                        width: '100%',
                        padding: '10px',
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <SuccessIcon/>
                    </div>
                    <Typography variant="h6" textAlign="center" >Success</Typography>
                    <Typography textAlign="center">{i18n.t('app.zoomAuthSuccess')}</Typography>
                </Stack>
            </Box >
        </div>

    );
};
const mapStateToProps = (state: any) => ({
    app4legalData: state.appData.app4legalData
});
export default connect(mapStateToProps, { ...AppDataStore.actionCreators })(ZoomAuthSuccess);


